// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__15jYh","section":"styles_section__377AV","input":"styles_input__3BfIE","addressSection":"styles_addressSection__2eXNR"};